import IFurnSearchPageRoot from "../root/IFurnSearchPageRoot";
import SearchPageRoot from "../root/SearchPageRoot";
import SearchWidgetRoot from "../root/SearchWidgetRoot";
import {renderWidget} from "./WidgetRenderer";
import {IBaseColorsConfig} from "../app/styles/themeStyles";
import {WidgetSettingsT} from "../shared/context/WidgetSettingsContext";
import {ContainerIdEnum} from "./initialISearchPanelModule";

export interface IInitSearchWidget extends WidgetSettingsT {
    themeBaseConfig?: IBaseColorsConfig;
    containerId: string;
}

/**
 * Инициализирует и рендерит различные виджеты поиска в зависимости от наличия контейнеров на странице.
 *
 * Эта функция используется как точка входа для интеграции разных реализаций поиска (страница, модалка, ifurn),
 * встраиваемых в разные части DOM-дерева, например, при использовании как внешнего JS-виджета.
 *
 * @param themeBaseConfig - объект конфигурации базовой темы (цвета, стили).
 * @param filterParams - параметры фильтрации, которые нужно передать в контекст.
 * @param excludeFilterFiled - список полей, которые необходимо исключить из фильтра.
 * @param apiChannel - канал API (например, язык ), специфичный для текущей интеграции.
 *
 * Поведение:
 * - Если найден контейнер `_isp-root-ifurn-page`, рендерит компонент `IFurnSearchPageRoot` с переданными настройками.
 * - Если найден контейнер `_isp-root-page`, рендерит `SearchPageRoot` с **пустыми** настройками (используется как общий виджет).
 * - Если найден контейнер `_isp-root-modal`, рендерит `SearchWidgetRoot` также с **пустыми** настройками.
 *
 * ⚠️ Контейнеры должны существовать в HTML-документе до вызова этой функции, иначе ничего не будет отрисовано.
 */


export const initSearchWidget = ({
                                     themeBaseConfig = {},
                                     filterParams = {},
                                     excludeFilterFiled = [],
                                     apiChannel = null,
                                     containerId
                                 }: IInitSearchWidget) => {
    const settings = {filterParams, excludeFilterFiled, apiChannel};

    if (ContainerIdEnum.ifurnId === containerId) {
        const ifurn = document.getElementById(containerId);
        if (ifurn) renderWidget(ifurn, IFurnSearchPageRoot, themeBaseConfig, settings);
    }
    if (ContainerIdEnum.pageId === containerId) {
        const page = document.getElementById(containerId);
        if (page) renderWidget(page, SearchPageRoot, themeBaseConfig,
            {
                filterParams: {},
                excludeFilterFiled: [],
                apiChannel: null,
            });
    }
    if (ContainerIdEnum.modalId === containerId) {
        const modal = document.getElementById(containerId);
        if (modal) renderWidget(modal, SearchWidgetRoot, themeBaseConfig,
            {
                filterParams: {},
                excludeFilterFiled: [],
                apiChannel: null,
            });
    }
};